/**
 * Pure decisions behind the portal's dialogs (replacing window.prompt /
 * window.confirm / window.alert): what a prompt answer resolves to, and
 * which button a dialog focuses by default.
 */

/**
 * A prompt's answer. `null` = the user cancelled, or entered nothing where
 * something was required (so callers can treat "cancelled" and "left it
 * blank" the same way, exactly as `window.prompt(...)?.trim()` did).
 * `allowEmpty` keeps '' as a meaningful answer ("hand over to nobody =
 * take over yourself").
 */
export function resolvePromptValue(
  raw: string | null,
  opts: { allowEmpty?: boolean } = {},
): string | null {
  if (raw === null) return null;
  const v = raw.trim();
  if (!v && !opts.allowEmpty) return null;
  return v;
}

/**
 * Default focus: a DESTRUCTIVE confirm focuses Cancel so Enter can't delete
 * something by reflex (the #191 rule); everything else focuses the primary.
 */
export function defaultFocus(kind: 'confirm' | 'alert', danger: boolean): 'cancel' | 'confirm' {
  return kind === 'confirm' && danger ? 'cancel' : 'confirm';
}
